import { getRequest } from "../requests";
import { URL_BASE } from '../constants';
import store from '../../redux/globalStore';
import { storeCategories } from '../../redux/modules/categories/categoriesActions';

export async function getAllCategories() {
    const categoriesPayload = await getRequest(`${URL_BASE}/categories`);
    store.dispatch(storeCategories(categoriesPayload.data));    
    return categoriesPayload;
}